import React from 'react';
import PropTypes from "prop-types";
import {SMCToggleSwitch} from "../SMCToggleSwitch";
import {lockedPlanImg, unlockedPlanImg} from '../../../assets/images/toggles';

/**
 *
 * @param {object} params
 * @param {boolean} [params.disabled]
 * @param {boolean} [params.ignoreDisabledContext]
 * @param {function} [params.onChange]
 * @param {boolean} [params.labelClickable]
 * @param {(string|number)} [params.height]
 * @param {(string|number)} [params.width]
 * @param {boolean} [params.checked]
 * @param {string} [params.label]
 * @param {('start'|'end')} [params.labelPosition]
 * @param {(string|number)} [params.labelWidth]
 * @param {string} [params.tooltip]
 * @param {boolean} [params.inline]
 * @param {*} [params.innerRef]
 * @param {string} [params.className]
 * @param {('small'|'medium')} [params.size]
 */
function SMCLockedToPlanToggle(props) {
    return (
        <SMCToggleSwitch onIcon={lockedPlanImg} offIcon={unlockedPlanImg} {...props}
                         size='medium' onBackgroundColor='#2E3F58' offBackgroundColor='#F0AD5E'/>
    )
}

SMCToggleSwitch.propTypes = {
    disabled: PropTypes.bool,
    ignoreDisabledContext: PropTypes.string,
    onChange: PropTypes.func,
    labelClickable: PropTypes.bool,
    labelHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.number,
    checked: PropTypes.bool,
    label: PropTypes.node,
    tooltip: PropTypes.node,
    labelPosition: PropTypes.oneOf(['start', 'end']),
    labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inline: PropTypes.bool,
    innerRef: PropTypes.node,
    className: PropTypes.string,
    onIcon: PropTypes.string,
    offIcon: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
}

export default React.memo(SMCLockedToPlanToggle);